import { render, staticRenderFns } from "./MemberPopups.vue?vue&type=template&id=6dd1b70b"
import script from "./MemberPopups.vue?vue&type=script&lang=ts"
export * from "./MemberPopups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports